<template>
  <div>
    <CCard v-if="generation">
      <CCardHeader>
        <div class="d-flex justify-content-between align-items-center">
          <h5>Детали генерации #{{ generation.id }} ({{ generationTypeText }})</h5>
          <CButton
            color="primary"
            size="sm"
            @click="$router.push('/promocodes/history')"
          >
            Назад к списку
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <div class="mb-4">
          <h6>Основная информация</h6>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Описание:</CCol>
            <CCol>{{ generation.description }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Тип генерации:</CCol>
            <CCol>{{ generationTypeText }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Количество промокодов:</CCol>
            <CCol>{{ generation.count }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Дата создания:</CCol>
            <CCol>{{ formatDate(generation.created_at) }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Создатель:</CCol>
            <CCol>{{ generation.administrator ? generation.administrator.email : '' }}</CCol>
          </CRow>
        </div>

        <div class="mb-4">
          <h6>Настройки промокодов</h6>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Длина кода:</CCol>
            <CCol>{{ generation.settings.length }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Минимальная сумма заказа:</CCol>
            <CCol>{{ generation.settings.min_sum }} руб.</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Дата начала:</CCol>
            <CCol>{{ generation.settings.date_start ? formatDate(generation.settings.date_start) : 'Не указана' }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Дата окончания:</CCol>
            <CCol>{{ generation.settings.date_finish ? formatDate(generation.settings.date_finish) : 'Не указана' }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Время жизни (дней):</CCol>
            <CCol>{{ generation.settings.term_day || 'Не ограничено' }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Количество заказов:</CCol>
            <CCol>{{ generation.settings.term_count }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Максимальное количество заказов у пользователя:</CCol>
            <CCol>{{ generation.settings.max_term_count_for_user || 'Не ограничено' }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Минимальное количество заказов у пользователя:</CCol>
            <CCol>{{ generation.settings.min_term_count_for_user || 'Не ограничено' }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Скидка (%):</CCol>
            <CCol>{{ generation.settings.discount_percent || 0 }}%</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Скидка (руб.):</CCol>
            <CCol>{{ generation.settings.discount_sum || 0 }} руб.</CCol>
          </CRow>
          <!-- Новые поля -->
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Скидка от ресторана (%):</CCol>
            <CCol>{{ generation.settings.entity_discount_percent || 0 }}%</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Скидка от ресторана (руб.):</CCol>
            <CCol>{{ generation.settings.entity_discount_sum || 0 }} руб.</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Комиссия МИРСИТИ (%):</CCol>
            <CCol>{{ generation.settings.mircity_commission || 0 }}%</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Отправка в интеграции:</CCol>
            <CCol>{{ generation.settings.accounting_in_integration ? 'Да' : 'Нет' }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Бесплатная доставка:</CCol>
            <CCol>{{ generation.settings.free_delivery ? 'Да' : 'Нет' }}</CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="3" class="text-muted">Включено:</CCol>
            <CCol>{{ generation.settings.enabled ? 'Да' : 'Нет' }}</CCol>
          </CRow>
        </div>

        <!-- Информация о сервисах -->
        <div class="mb-4" v-if="hasServiceInfo">
          <h6>Применяется в сервисах</h6>
          <CRow class="mb-2" v-if="generation.settings.all_restaurants">
            <CCol sm="3" class="text-muted">Рестораны:</CCol>
            <CCol>Все рестораны</CCol>
          </CRow>
          <CRow class="mb-2" v-else-if="generation.settings.restaurants && generation.settings.restaurants.length">
            <CCol sm="3" class="text-muted">Рестораны:</CCol>
            <CCol>
              <span v-for="restaurantId in generation.settings.restaurants" :key="restaurantId" class="mr-2">
                <span 
                  v-if="allRestaurants[restaurantId]"
                  class="text-primary cursor-pointer"
                  style="text-decoration: underline; margin-right: 8px;"
                  @click="$router.push(`/restaurants/${restaurantId}`)"
                >
                  {{ allRestaurants[restaurantId].title }}
                </span>
              </span>
            </CCol>
          </CRow>
          
          <CRow class="mb-2" v-if="generation.settings.all_grocers">
            <CCol sm="3" class="text-muted">Магазины продуктов:</CCol>
            <CCol>Все магазины продуктов</CCol>
          </CRow>
          <CRow class="mb-2" v-else-if="generation.settings.grocers && generation.settings.grocers.length">
            <CCol sm="3" class="text-muted">Магазины продуктов:</CCol>
            <CCol>
              <span v-for="grocerId in generation.settings.grocers" :key="grocerId" class="mr-2">
                <span 
                  v-if="allGrocers[grocerId]"
                  class="text-primary cursor-pointer"
                  style="text-decoration: underline; margin-right: 8px;"
                  @click="$router.push(`/grocers/${grocerId}`)"
                >
                  {{ allGrocers[grocerId].title }}
                </span>
              </span>
            </CCol>
          </CRow>
          
          <div v-if="filteredEntityTypes && filteredEntityTypes.length">
            <CRow 
              v-for="type in filteredEntityTypes" 
              :key="type.id"
              class="mb-2"
            >
              <CCol sm="3" class="text-muted">{{ type.title }}:</CCol>
              <CCol>
                <div v-if="isEntityTypeSelected(type.id)" class="font-weight-bold mb-1">
                  Все сервисы «{{ type.title }}»
                </div>
                <div v-if="type.services && type.services.length">
                  <span v-for="entity in type.services" :key="entity.id" class="mr-2">
                    <span 
                      v-if="isEntitySelected(entity.id)"
                      class="text-primary cursor-pointer"
                      style="text-decoration: underline; margin-right: 8px;"
                      @click="$router.push(`/entities/${type.code}/${entity.id}`)"
                    >
                      {{ entity.title }}
                    </span>
                  </span>
                </div>
              </CCol>
            </CRow>
          </div>
        </div>

        <div class="mt-4">
          <CCard>
            <CCardHeader>
              <div class="d-flex justify-content-between align-items-center">
                <h5>Сгенерированные промокоды {{ generatedData.length ? `(${generatedData.length})` : '' }}</h5>
                <div v-if="generatedData.length">
                  <CButton
                    color="success"
                    class="mr-2"
                    @click="copyToClipboard"
                  >
                    Копировать в буфер
                  </CButton>
                  <CButton
                    color="primary"
                    @click="downloadCSV"
                  >
                    Скачать CSV
                  </CButton>
                </div>
              </div>
            </CCardHeader>
            <CCardBody>
              <div v-if="loading" class="text-center py-3">
                <CSpinner color="primary" />
                <p class="mt-2">Загрузка промокодов...</p>
              </div>
              <CDataTable
                v-else-if="generatedData.length"
                :items="generatedData"
                :fields="[
                  { key: 'user_identifier', label: 'Идентификатор пользователя' },
                  { key: 'code', label: 'Промокод' }
                ]"
                bordered
                striped
                small
              >
                <template #user_identifier="{item}">
                  <td>
                    {{ item.user_identifier }}
                  </td>
                </template>
                <template #code="{item}">
                  <td>
                    <span class="code-item">{{ item.code }}</span>
                  </td>
                </template>
              </CDataTable>
              <div v-else class="text-center py-3">
                <p>Нет данных о промокодах</p>
              </div>
            </CCardBody>
          </CCard>
        </div>
      </CCardBody>
    </CCard>
    <CCard v-else>
      <CCardBody>
        <div class="text-center py-5">
          <CSpinner color="primary" />
          <p class="mt-3">Загрузка данных...</p>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'HistoryDetail',
  data() {
    return {
      generation: null,
      generatedData: [],
      loading: false,
      allRestaurants: {},
      allGrocers: {},
      allEntityTypes: []
    };
  },
  computed: {
    generationTypeText() {
      if (!this.generation) return '';
      
      switch (this.generation.type) {
        case 'personal':
          return 'Персональная';
        case 'mass':
          return 'Массовая';
        default:
          return this.generation.type || '';
      }
    },
    hasServiceInfo() {
      if (!this.generation || !this.generation.settings) return false;
      
      const settings = this.generation.settings;
      return (
        settings.all_restaurants || 
        (settings.restaurants && settings.restaurants.length) ||
        settings.all_grocers || 
        (settings.grocers && settings.grocers.length) ||
        (settings.entity_types && settings.entity_types.length) ||
        (settings.entities && settings.entities.length)
      );
    },
    filteredEntityTypes() {
      if (!this.generation || !this.generation.settings || !this.allEntityTypes.length) return [];
      
      return this.allEntityTypes.filter(type => {
        // Проверяем, выбран ли тип сервиса
        const isTypeSelected = this.isEntityTypeSelected(type.id);
        
        // Фильтруем сервисы, которые выбраны
        if (type.services && type.services.length) {
          type.services = type.services.filter(entity => 
            this.isEntitySelected(entity.id)
          );
        }
        
        // Возвращаем true, если тип выбран или есть выбранные сервисы
        return isTypeSelected || (type.services && type.services.length > 0);
      });
    }
  },
  async created() {
    await this.fetchData();
    await this.initBusiness();
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
    async fetchData() {
      const { id } = this.$route.params;
      this.loading = true;
      try {
        const response = await this.axios.get(`/promocodes/generations/${id}`);
        this.generation = response.data;
        
        // Process promocodes for display
        if (this.generation && this.generation.promocodes && this.generation.promocodes.length) {
          this.generatedData = this.generation.promocodes.map(promocode => ({
            code: promocode.code,
            user_identifier: promocode.user_identifier || '-'
          }));
        } else if (this.generation && this.generation.codes && this.generation.codes.length) {
          // Fallback for old format
          this.generatedData = this.generation.codes.map(item => ({
            code: item.code,
            user_identifier: item.user_identifier || '-'
          }));
        }
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка при загрузке данных');
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async initBusiness() {
      try {
        // Restaurants
        const restaurants = (await this.axios.get('/restaurants')).data;
        this.allRestaurants = {};
        restaurants.forEach(restaurant => {
          this.allRestaurants[restaurant.id] = restaurant;
        });

        // Grocers
        const grocers = (await this.axios.get('/grocers')).data;
        this.allGrocers = {};
        grocers.forEach(grocer => {
          this.allGrocers[grocer.id] = grocer;
        });

        // Entity Types
        this.allEntityTypes = (await this.axios.get('/entities-type')).data;
        this.allEntityTypes = await Promise.all(this.allEntityTypes.map(async type => {
          type.services = (await this.axios.get(`/entities/${type.code}`)).data;
          return type;
        }));
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка при загрузке данных сервисов');
        console.error(error);
      }
    },
    isEntityTypeSelected(typeId) {
      return this.generation && 
             this.generation.settings && 
             this.generation.settings.entity_types && 
             this.generation.settings.entity_types.includes(typeId);
    },
    isEntitySelected(entityId) {
      return this.generation && 
             this.generation.settings && 
             this.generation.settings.entities && 
             this.generation.settings.entities.includes(entityId);
    },
    copyToClipboard() {
      let text;
      if (this.generatedData.length) {
        // Format: user_identifier,code
        text = this.generatedData.map(item => 
          `${item.user_identifier},${item.code}`
        ).join('\n');
      } else if (this.generation.codes) {
        text = this.generation.codes.join('\n');
      } else {
        this.$root.$emit('showError', 'Нет данных для копирования');
        return;
      }
      
      navigator.clipboard.writeText(text)
        .then(() => {
          this.$root.$emit('showSuccess', 'Промокоды скопированы в буфер обмена');
        })
        .catch(() => {
          this.$root.$emit('showError', 'Не удалось скопировать в буфер обмена');
        });
    },
    downloadCSV() {
      let csvContent;
      
      if (this.generatedData.length) {
        // Add generation details as comments
        csvContent = `# Генерация промокодов #${this.generation.id}\n`;
        csvContent += `# Тип: ${this.generationTypeText}\n`;
        csvContent += `# Описание: ${this.generation.description || '-'}\n`;
        csvContent += `# Дата создания: ${this.formatDate(this.generation.created_at)}\n`;
        csvContent += `# Количество: ${this.generatedData.length}\n\n`;
        
        // Add header row
        csvContent += 'Идентификатор,Промокод\n';
        // Add data rows
        csvContent += this.generatedData.map(item => 
          `${item.user_identifier},${item.code}`
        ).join('\n');
      } else if (this.generation.codes) {
        // Add generation details as comments
        csvContent = `# Генерация промокодов #${this.generation.id}\n`;
        csvContent += `# Тип: ${this.generationTypeText}\n`;
        csvContent += `# Описание: ${this.generation.description || '-'}\n`;
        csvContent += `# Дата создания: ${this.formatDate(this.generation.created_at)}\n`;
        csvContent += `# Количество: ${this.generation.codes.length}\n\n`;
        
        csvContent += this.generation.codes.join('\n');
      } else {
        this.$root.$emit('showError', 'Нет данных для скачивания');
        return;
      }
      
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      
      const now = new Date();
      const filename = `promocodes_${this.generation.id}_${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}.csv`;
      
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
};
</script>

<style scoped>
.code-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 10px;
  background-color: #f8f9fa;
}

.code-item {
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 5px 10px;
  font-family: monospace;
  font-size: 14px;
}
</style> 